module.exports = __webpack_public_path__ + "static/automatic-ai_2-c24517564b3348a98c9ec4a15473d84d.jpg";